import { GetterTree } from 'vuex'
import { SceneState } from './types'
import { RootState } from '../../types'

export const getters: GetterTree<SceneState, RootState> = {
  orbit: ({ orbit }): boolean => orbit,
}
